import {
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  StackOwnProps,
  Typography,
} from '@mui/material';
import { ReactElement } from 'react';

import StickyBlock from '../StickyBlock';

interface CompontentProps {
  buttons?: ReactElement;
  header?: ReactElement;
  children: React.ReactNode;
  title?: string;
  direction?: StackOwnProps['direction'];
  showContentDivider?: boolean;
}

export const FormCard = ({
  children,
  buttons,
  header,
  title,
  direction = 'row',
  showContentDivider = true,
}: CompontentProps) => {
  return (
    <>
      <Card variant="outlined" sx={{ width: '100%' }}>
        <CardContent>
          <Stack
            direction="column"
            spacing={2}
            sx={{ justifyContent: 'space-between' }}
          >
            {title && <Typography variant="h6">{title}</Typography>}
            {header && header}
            {showContentDivider && <Divider />}
            {children}
          </Stack>
        </CardContent>
      </Card>
      {buttons &&
        (direction.toString().includes('column') ? (
          <Grid sx={{ display: 'flex', justifyContent: 'end' }}>{buttons}</Grid>
        ) : (
          <StickyBlock>{buttons}</StickyBlock>
        ))}
    </>
  );
};
